module.exports = __webpack_public_path__ + "static/projekt_indywidualny_d09-56e9b24d59c9268af1be007157588fa7.jpg";